import axios from 'axios';

export default {
  generateQRCode: data => axios.put('/api/v1/auth/qr', data),
  resetOwnPassword: data => axios.put('/api/v1/users/password', data)
};
